import { render, staticRenderFns } from "./form_confirm_monetization_component.vue?vue&type=template&id=5cd013a3&scoped=true"
import script from "./form_confirm_monetization_component.vue?vue&type=script&lang=js"
export * from "./form_confirm_monetization_component.vue?vue&type=script&lang=js"
import style0 from "./form_confirm_monetization_component.vue?vue&type=style&index=0&id=5cd013a3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd013a3",
  null
  
)

export default component.exports